import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Interest } from '@app/api/api-models/interests/InterestApiModel';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class InterestsService {
  public apiUrl = 'interests';

  constructor(private http: HttpClientService) {}

  public getList(): Observable<Interest[]> {
    return this.http.get<Interest[]>(`${this.apiUrl}/get-list`);
  }
}
